module.exports = __webpack_public_path__ + "static/media/heart46.0bf48fe0.svg";